import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import Faq from "../../Page-section/contentwriting/Faq";
import Portfolio from "../../components/portfolio";

import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
  FaPaperPlane,
} from "react-icons/fa";
import Contentservice from "../../Page-section/contentwriting/Contentservice";

const Contentprocess = () => {
  const points = [
    "Increased website visitors",
    "Better search engine rankings",
    "Higher engagement and brand awareness",
    "Improved lead generation",
    "Long-term business growth",
  ];

  const point = [
    "Cost-effective answers",
    "Access to skilled content experts",
    "Scalable content strategies",
    "Faster turnaround time",
    "High-first-class output",
  ];

  const steps = [
    {
      id: 1,
      title: "Research & Analysis",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We examine your target market, competition, and market tendencies.",
    },
    {
      id: 2,
      title: "Strategy Development",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "We create a custom designed content plan aligned along with your dreams.",
    },
    {
      id: 3,
      title: "Content Creation",
      color: "green",
      icon: <FaCode />,
      desc: "Our crew develops brilliant, attractive, and search engine marketing-friendly content material.",
    },
    {
      id: 4,
      title: "Optimization",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We optimize content using nice search engine optimization practices to enhance rankings.",
    },
    {
      id: 5,
      title: "Performance Tracking",
      color: "green",
      icon: <FaAward />,
      desc: "We screen consequences and continuously enhance techniques.",
    },
    {
      id: 6,
      title: "Continuous Improvement",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "We constantly refine and update your content strategy based on performance statistics, user conduct.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
             <li className="active">
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
              <li>
              <Link to="/social-media-marketing-services">Social Media Marketing</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
           
            <li>
              <Link to="/ai-automation-services">AI Automation Services</Link>
            </li>

            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+919315020291"> +91 9315020291</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why Content Marketing is Important for Your Business</h2>
            <p>
              Content advertising is not just about writing articles it’s
              approximately delivering fee in your audience at every stage of
              their adventure. A dependable
              <b> content marketing company in india</b> understands the way to
              create content that aligns together with your business goals and
              target audience desires.Here are some key advantages of investing
              in content marketing services:
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              Businesses that accomplice with the best content marketing
              companies are able to live beforehand in their competitors by
              continuously delivering extremely good content.
            </p>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Our Expertise in Content Marketing</h2>
            <p>
              As a main <b>content marketing company</b> and marketing
              organization, we specialize in growing customized content material
              strategies that power actual consequences. Our team of specialists
              specializes in know-how your logo, target market, and industry to
              deliver content that resonates and converts.
            </p>

            <p>
              Being identified a few of the best content marketing companies, we
              follow a records-pushed method to make certain every piece of
              content material contributes in your commercial enterprise
              increase. Our purpose is that will help you build accept as true
              with, authority, and lengthy-lasting relationships together with
              your target market.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>What Makes Us the Best Content Marketing Agency?</h3>
            <p>
              We stand out as the <b>best content marketing agency</b> by delivering
              high-quality, SEO-optimized content, data-driven strategies, and
              customized solutions that boost traffic, engagement, and
              conversions for long-term business growth.
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Strategic Approach</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>High-Quality Content</h4>
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Industry Expertise</h4>
                </div>
              </div>
            </div>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Data-Driven Results</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Affordable Solutions</h4>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Contentservice />

        <section className="work-process-section">
          <h3 className="work-title">
            How Our Content Marketing Process Works
          </h3>
          <p className="work-subtitle">
            Our structured approach makes us one of the{" "}
            <b>best content marketing companies</b> inside the industry:
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Benefits of Choosing a Content Marketing Company in India</h2>
            <p>
              Working with a expert content marketing company in india offers
              several blessings:
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Why Choose Us?</h3>
                <p>
                  There are many options available, but choosing the right
                  content marketing company makes all the difference. Here’s why
                  we stand out:
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Experienced content professionals</h3>
              </div>
              <div className="card">
                <h3>Customized content strategies</h3>
              </div>
              <div className="card">
                <h3>Proven track record of success</h3>
              </div>
              <div className="card">
                <h3>Focus on ROI and conversions</h3>
              </div>
              <div className="card">
                <h3>Dedicated support</h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started with the Best Content Marketing Services</h3>
          </div>
          <div className="operations-right">
              <p>
                If you want to grow your business online, investing in
                professional content marketing services is the right decision.
                Our team is here to help you create powerful content that
                attracts, engages, and converts your audience.
              </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Contentprocess;
